import React from 'react';
import PropTypes from 'prop-types';
import SpanStyled from './Span.styles';

const Span = ({ type, variant, align, weight, children }) => (
  <SpanStyled type={type} variant={variant} align={align} weight={weight}>
    {children}
  </SpanStyled>
);

Span.defaultProps = {
  type: '1',
  variant: 'enabled',
  weight: 'regular',
  align: 'left',
};

Span.propTypes = {
  type: PropTypes.oneOf(['1', '2', '3', '4', '5', '6']).isRequired,
  variant: PropTypes.oneOf([
    'disabled',
    'enabled',
    'link',
    'neutral',
    'neutral-2',
    'primary',
    'primary-2',
    'primary-3',
    'primary-4',
    'white',
  ]).isRequired,
  weight: PropTypes.oneOf(['light', 'regular', 'bold']).isRequired,
  align: PropTypes.oneOf(['center', 'right', 'left']).isRequired,
};

export default Span;
